import css from 'styled-jsx/css';

const staticStyles = css.global`
  .ShuftiproContainer {
    background: white;
    height: max-content;

    iframe {
      border: none;
      padding-top: 20px;
    }
  }
`;

export { staticStyles };
